// merge any amount of listeners and give them proper names
import {
  ItemEventListeners,
  ItemEventListenersResult,
  MenuItemEvent,
} from './types';

export const mergeListeners = (
  ...listeners: Array<ItemEventListeners>
): ItemEventListenersResult => {
  const onEnter = (e: MenuItemEvent) => listeners.forEach(l => l.onEnter(e));
  const onLeave = (e: MenuItemEvent) => listeners.forEach(l => l.onLeave(e));
  return {
    onMouseEnter: onEnter,
    onFocusCapture: onEnter,
    onMouseLeave: onLeave,
    onBlurCapture: onLeave,
  };
};
